module.exports = __webpack_public_path__ + "src/images/products/active/17_Thermal Cotton Full Zip Hoodie.png";